// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Nnfm","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2PpyE","gfeWrapper":"CalendarEvent_gfeWrapper__3tOTH"};